<template>
  <div>
    <div class="page-title">New Schedule</div>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Schedule" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.schedules.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Schedule.new();
      this.form = data;
    },
    async create() {
      await this.$api.Schedule.create(this.form);
      this.$router.push("/widgets/schedules");
    },
  },
};
</script>

<style></style>
